<div class="sensor_threshold_popup">
    <div *ngIf="loading" class="loading-container">
      <img src="./assets/chart_loader.gif" alt="Loading...">
    </div>
    <div *ngIf="!loading">
      <!-- Your form fields here, using the `data` object -->
      <div class="modal-header">
        <h4 class="modal-title">Sensor Threshold Value</h4>
      </div>
  
      <div class="modal-body">
        <div class="table-responsive">
          <div *ngIf="powerFactorData && powerFactorData.length">
          
            <table class="table">
              <thead>
                <tr>
                  <th>Sensor Group</th>
                  <th>Range</th>
                  <th>Red</th>
                  <th>Yellow</th>
                  <th>Green</th>
                  
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of powerFactorData" class="text-center">
                  <td>{{ item.metric_type }}</td>
                  <td>
                    <div style="display: flex; justify-content: center; gap: 10px; align-items: center;">
                      <input type="hidden" [(ngModel)]="item.id" />
                      <input type="text" [(ngModel)]="item.base_value" class="form-control" placeholder="Min" style="width: 80px; text-align: center;" />
                      <input type="text" [(ngModel)]="item.max_value" class="form-control" placeholder="Max" style="width: 80px; text-align: center;" />
                    </div>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: center;">
                      <input type="text" [(ngModel)]="item.threshold_1" class="form-control" style="width: 80px; text-align: center;" />
                    </div>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: center;">
                      <input type="text" [(ngModel)]="item.threshold_2" class="form-control" style="width: 80px; text-align: center;" />
                    </div>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: center;">
                      <input type="text" [(ngModel)]="item.threshold_3" class="form-control" style="width: 80px; text-align: center;" />
                    </div>
                  </td>
                </tr>
              </tbody>
              
              
              
            </table>
          </div>
          
          <div *ngIf="otherData && otherData.length">
           
            <table class="table">
              <thead>
                <tr>
                  <th>Sensor Group</th>
                  <th>Range</th>
                  <th>Under - Red</th>
                  <th>Under - Yellow</th>
                  <th>Under - Green</th>
                  <th>Over - Green</th>
                  <th>Over - Yellow</th>
                  <th>Over - Red</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of otherData">
                  <td>{{ item.metric_type }}</td>
                  <td>
                    <div class="flexnalign">
                      <div class="input-group width_70 m_r_10">
                        <input type="hidden" [(ngModel)]="item.id" class="form-control"/>
                        <input type="text" [(ngModel)]="item.base_value" class="form-control" placeholder="Min"/>
                      </div>
                      <div class="input-group width_70">
                        <input type="text" [(ngModel)]="item.max_value" class="form-control" placeholder="Max"/>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.threshold_1" class="form-control"/>
                    </div>
                  </td>
                  <td>
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.threshold_2" class="form-control"/>
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.threshold_3" class="form-control"/>
                    </div>
                  </td>
                  <td *ngIf="item.metric_type !== 'PowerFactor'" class="text-center">
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.orieX_default" class="form-control"/>
                    </div>
                  </td>
                  <td *ngIf="item.metric_type !== 'PowerFactor'" class="text-center">
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.orieY_default" class="form-control"/>
                    </div>
                  </td>
                  <td *ngIf="item.metric_type !== 'PowerFactor'" class="text-center">
                    <div class="input-group width_100">
                      <input type="text" [(ngModel)]="item.orieZ_default" class="form-control"/>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
       
        <!-- <textarea class="form-control" placeholder=".....comment"></textarea> -->
      </div>
      <div class="modal-footer">
    
          <button mat-raised-button color="primary" (click)="onSave()">Save</button>
          <button mat-raised-button color="warm" (click)="onClose()">Close</button>
      </div>
    </div>
  
</div>
<!---------------  Plant-Dashboard-Comment ------------------------->